import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { PERMISSIONS } from "../permissions/permissions-map";

const usePermissions = () => {
  const { role } = useSelector((store) => store.global.user);
  const permissions = useMemo(() => PERMISSIONS[role], [role]);

  const hasPermission = useCallback(
    ({ scopes }) => {
      const scopesMap = {};
      scopes.forEach((scope) => {
        scopesMap[scope] = true;
      });

      return permissions?.some((permission) => scopesMap[permission]);
    },
    [permissions]
  );

  return {
    hasPermission,
  };
};

export default usePermissions;
